export default "__VITE_ASSET__49841900__"